import numeral from "numeral"

export default {
    formatNumberWithCommas(value) {
        return numeral(value).format('0,0.00');
    }
}